import * as React from "react";
import getDisplayName from "authentication/helpers/getDisplayName";
import { DocumentTitle } from "components/common";
import WizardPageHeader from "components/authentication/directoryServices/ldap/WizardPageHeader";
import SectionComponent from "components/common/Section/SectionComponent";
import LicenseCheck from "license/LicenseCheck";
import { AUTH_SERVICE_TYPE } from "authentication/components/saml/constants";
import SAMLBackendConfigWizard from "authentication/components/saml/config/SAMLBackendConfigWizard";
const SAMLBackendCreate = () => {
  const title = `Create ${getDisplayName(AUTH_SERVICE_TYPE)} Authentication Service`;
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title }, /* @__PURE__ */ React.createElement(WizardPageHeader, { title }), /* @__PURE__ */ React.createElement(SectionComponent, { title }, /* @__PURE__ */ React.createElement(LicenseCheck, null, ({ licenseIsValid }) => /* @__PURE__ */ React.createElement(SAMLBackendConfigWizard, { licenseIsValid }))));
};
export default SAMLBackendCreate;
